import { useDateFnsLocale } from "@/lib/date-fns-locale";
import { formatDistanceToNow } from "date-fns";

/** "5 minutes ago" in the app's language; null when the date is unknown. */
export function useRelativeTime(iso: string | null): string | null {
  const locale = useDateFnsLocale();
  if (!iso) {
    return null;
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return formatDistanceToNow(date, { addSuffix: true, locale });
}
